import React from 'react'

import TV from './../../../UI/general/TV.svg'
import desktop from './../../../UI/general/Desktop.svg'

interface Props {
  isSalaDeVentasMode: boolean,
  salaDeVentasOpened: boolean
}

interface State {}

class SalaDeVentas extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {

    }
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.salaDeVentasOpened ? 'sala-de-ventas-container fade-in':'sala-de-ventas-container fade-out'}>
          <img src={this.props.isSalaDeVentasMode ? TV:desktop} alt=''/>
          <div>{this.props.isSalaDeVentasMode ? 'Estás viendo Modo Sala de Ventas':'Estás viendo Modo Escritorio'}</div>
        </div>
      )
  }
}

export default SalaDeVentas